import { render, staticRenderFns } from "./AddOrEditTalentDrawer.vue?vue&type=template&id=0c72cde8&scoped=true&"
import script from "./AddOrEditTalentDrawer.vue?vue&type=script&lang=js&"
export * from "./AddOrEditTalentDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AddOrEditTalentDrawer.vue?vue&type=style&index=0&id=0c72cde8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72cde8",
  null
  
)

export default component.exports